import React from 'react';
import './Popup.css'; // Import the CSS file
import ControllerInfo from './ControllerInfo.js';

function DisplayControllerButtonInfo({ showPopup, onClose, image, lureBtnLabel }) {
    if (!showPopup) {
        return null; // Don't render if showPopup is false
    }

    let blurAmount = '0.75px';
    const crossButtonStyle = {
        top: '2vh', // 2% of viewport height
        right: '2vw', // 2% of viewport width
    };

    return (
        <div>
            <div className="dark-background" style={{ '--blur-value': `blur(${blurAmount})` }} >
                <button onClick={onClose} className="text cross-button" style={crossButtonStyle}>&#x2715;</button>
            </div>
            <div style={{ position: 'relative', top: -100 }}>
                <ControllerInfo image={image} lureBtnLabel={lureBtnLabel} />
            </div>
        </div >
    );
};
export default DisplayControllerButtonInfo;